import { createUseStyles } from 'react-jss'
import { textEllipsisMultiline } from '../../../../../../../styles/mixins/text'

const useStyles = createUseStyles({
  footer: {
    height: 35,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '4px 5px 3px'
  },
  info: {
    width: 85,
    maxWidth: '60%',
    height: '100%',
    position: 'relative'
  },

  // headline
  carouseHeadlineText: {
    fontSize: 8,
    ...textEllipsisMultiline(2),
    position: 'absolute'
  },
  skeletonCarouselHeadline: {
    maxHeight: 7,
    height: 7
  },

  // description
  carouseDescriptionText: {
    fontSize: 7,
    position: 'absolute',
    bottom: 0
  },

  skeletonCarouselDescription: {
    width: 50
  }
})

export default useStyles
